import { render, staticRenderFns } from "./AccessPointGroupSummary.vue?vue&type=template&id=8d803410&"
import script from "./AccessPointGroupSummary.vue?vue&type=script&lang=js&"
export * from "./AccessPointGroupSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports